import styled from 'styled-components';

export const ModalTitle = styled.div`
  background: #111111;
  color: white;
  font-size: 1.1rem;
  line-height: 1.5;
  padding: 1em;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 1.3rem;
  }

  @media (min-width: 1024px) {
    margin: 1rem 1rem 0;
  }

  .br1 {
    @media (min-width: 1024px) {
      display: none;
    }
  }
`;
